/**
 * An object representing various file types and their corresponding MIME types.
 *
 * @property {string} PDF - The MIME type for PDF files.
 * @property {string} DOC - The MIME type for DOC files.
 * @property {string} DOCX - The MIME type for DOCX files.
 * @property {string} XLS - The MIME type for XLS files.
 * @property {string} XLSX - The MIME type for XLSX files.
 * @property {string} JPG - The MIME type for JPG files.
 * @property {string} PNG - The MIME type for PNG files.
 * @property {string} GIF - The MIME type for GIF files.
 * @property {string} SVG - The MIME type for SVG files.
 * @property {string} MSG - The file extension for MSG files. (Email files - Outlook)
 * @property {string} EML - The file extension for EML files. (Email files - Apple Mail)
 */
export const FileTypes = {
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  JPG: 'image/jpeg',
  PNG: 'image/png',
  GIF: 'image/gif',
  SVG: 'image/svg+xml',
  MSG: '.msg',
  EML: '.eml'
};
